export type TranslateParams = Readonly<Record<string, string | number>>;

const PLACEHOLDER = /\{\{\s*([\w.]+)\s*\}\}/g;

/**
 * Replaces `{{name}}` placeholders with values from `params`.
 * Syntax is deliberately i18next-compatible so that the inline default texts
 * used across the framework are valid i18next values verbatim.
 * Unknown placeholders are left untouched.
 */
export function interpolate(text: string, params?: TranslateParams): string {
  if (!params) {
    return text;
  }
  return text.replace(PLACEHOLDER, (match, name: string) => {
    const value = params[name];
    return value === undefined ? match : String(value);
  });
}
